//
//
//
//
//
//
//
//
//
//
//

import { BRANCH_MOSCOW } from '@/const/branch'

export default {
  name: 'AlgFlocktory',
  props: {
    name: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
  },
  computed: {
    visible() {
      return [BRANCH_MOSCOW].includes(this.$getTextMainSetting('branch_id'))
    },
  },
}
